import Hotkeys from 'react-hot-keys';
import { motion } from 'framer-motion';
import { track } from '../../../../tracking';
import { TrialOrderType } from '../../../../pages/trialOrder/TrialOrderHomePage';
import { useHistory } from 'react-router-dom';
import { GO_TO_HE_DASHBOARD } from '../../../../routes/paths';

const ExitTrialWarningModal: React.FC<{
    type?: TrialOrderType;
    onResumeTrial: () => void;
}> = ({ type, onResumeTrial }) => {
    const history = useHistory();

    const onResumeTrialClick = () => {
        onResumeTrial();
        track('RESUME_TRIAL_BUTTON_CLICK', { type });
    };

    const onExitClick = () => {
        history.replace(GO_TO_HE_DASHBOARD('not-ordered'));
        const shepherdTourDivs = document.getElementsByClassName(
            'shepherd-tour',
        ) as HTMLCollectionOf<HTMLElement>;
        Array.from(shepherdTourDivs).forEach((ele) => ele && ele.remove());
        track('EXIT_TRIAL_BUTTON_CLICK', { type });
    };

    return (
        <Hotkeys keyName="esc">
            <motion.div
                initial={{ opacity: 0 }}
                exit={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                style={{ zIndex: 20 }}
                transition={{ duration: 0.2, ease: 'linear' }}
                className="font-lato select-none"
            >
                <div className="modal-overlay absolute inset-0 bg-darwin-neutral-1000 bg-opacity-50 z-50"></div>
                <div
                    className="modal-content space-y-16"
                    style={{
                        position: 'absolute',
                        width: '350px',
                        background: 'transparent',
                    }}
                >
                    <div className="px-16 py-24 bg-white rounded-4 space-y-16">
                        <div className="relative">
                            <p className="text-center font-700 text-16">
                                Are you sure you want to exit?
                            </p>
                            <button onClick={onResumeTrialClick} className="absolute top-5 right-0">
                                <svg
                                    className="w-14 h-14 fill-text-secondary"
                                    viewBox="0 0 12 12"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M10.75 9.71875C11.0312 10.0312 11.0312 10.5 10.75 10.7812C10.4375 11.0938 9.96875 11.0938 9.6875 10.7812L6 7.0625L2.28125 10.7812C1.96875 11.0938 1.5 11.0938 1.21875 10.7812C0.90625 10.5 0.90625 10.0312 1.21875 9.71875L4.9375 6L1.21875 2.28125C0.90625 1.96875 0.90625 1.5 1.21875 1.21875C1.5 0.90625 1.96875 0.90625 2.25 1.21875L6 4.96875L9.71875 1.25C10 0.9375 10.4688 0.9375 10.75 1.25C11.0625 1.53125 11.0625 2 10.75 2.3125L7.03125 6L10.75 9.71875Z" />
                                </svg>
                            </button>
                        </div>

                        <div className="flex items-start justify-center space-x-8">
                            <div className="relative top-3">
                                <svg
                                    className="w-16 h-16 fill-darwin-neutral-600"
                                    viewBox="0 0 14 14"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M7.4 13.625C3.79453 13.625 0.9 10.7305 0.9 7.125C0.9 3.54492 3.79453 0.625 7.4 0.625C10.9801 0.625 13.9 3.54492 13.9 7.125C13.9 10.7305 10.9801 13.625 7.4 13.625ZM7.4 3.875C7.04453 3.875 6.79062 4.1543 6.79062 4.48438V7.32812C6.79062 7.68359 7.04453 7.9375 7.4 7.9375C7.73008 7.9375 8.00937 7.68359 8.00937 7.32812V4.48438C8.00937 4.1543 7.73008 3.875 7.4 3.875ZM8.2125 9.5625C8.2125 9.13086 7.83164 8.75 7.4 8.75C6.94297 8.75 6.5875 9.13086 6.5875 9.5625C6.5875 10.0195 6.94297 10.375 7.4 10.375C7.83164 10.375 8.2125 10.0195 8.2125 9.5625Z" />
                                </svg>
                            </div>

                            <p className="text-center text-darwin-neutral-900">
                                New users who complete this trial are able to place orders and track
                                them effortlessly. Completing this trial only takes 2 mins.
                            </p>
                        </div>

                        <div className="grid grid-cols-2 space-x-16 pt-12">
                            <button
                                className="p-8 border border-darwin-accent-bright-blue-800 text-darwin-accent-bright-blue-800 rounded-4 font-700"
                                onClick={onResumeTrialClick}
                            >
                                Resume trial
                            </button>
                            <button
                                className="flex items-center justify-center p-8 text-white bg-darwin-accent-bright-blue-800 rounded-4 font-700"
                                onClick={onExitClick}
                            >
                                Exit
                            </button>
                        </div>
                    </div>
                </div>
            </motion.div>
        </Hotkeys>
    );
};

export default ExitTrialWarningModal;
